var React = require('react');

function Solutionplus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"30","height":"30","rx":"15","fill":"#FCF0F5","key":0}),React.createElement("line",{"x1":"15","y1":"8","x2":"15","y2":"22","stroke":"#F3336C","strokeWidth":"2","key":1}),React.createElement("line",{"x1":"8","y1":"15","x2":"22","y2":"15","stroke":"#F3336C","strokeWidth":"2","key":2})]);
}

Solutionplus.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Solutionplus;

Solutionplus.default = Solutionplus;
